import React, { useRef } from 'react';
import { context } from '../../../../context';
import { StatusStyled } from './Styled';
import SadFace from '../../../../svg/sadFace.svg';
import { Title, Paragraph, Margin, Button } from '../..';

const Fail = () => {
  const { history, urlData } = React.useContext(context);
  const redirectToHome = () => history.push('/');
  const divRef = useRef<HTMLDivElement>(null);
  const App = urlData?.app;
  const buttonWeb = App ? null : (
    <>
      <Button onClick={redirectToHome} variant="secondary">
        página inicial
      </Button>
    </>
  );

  React.useEffect(() => {
    divRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div ref={divRef}>
      <StatusStyled>
        <SadFace width="120px" height="120px" />
        <Margin bottom={40} />
        <Title>poxa, aconteceu um problema</Title>
        <Paragraph>A gente tá trabalhando pra resolver isso.</Paragraph>
        <Paragraph>Tente de novo mais tarde.</Paragraph>
        <Margin bottom={32} />
        {buttonWeb}
      </StatusStyled>
    </div>
  );
};

export default Fail;
export { Fail };
